var orderStatus = function () {
    var uniqueId = location.pathname.split('/').slice(-1).pop();
    var elModal = $('.order-status-change-notification-modal');
    var elOrderStatusId = $('[data-order-status-id]');
    var elOrderStatusName = $('.order-status-name');

    setInterval(function () {

        var orderStatusId = elOrderStatusId.attr('data-order-status-id');

        console.log(orderStatusId)

        $.ajax({
            type: "GET",
            url: App.prototype.apiAddress + 'orders/status/' + uniqueId,
            dataType: "json",
            success: function (data) {

                if (orderStatusId != data.id) {

                    elOrderStatusName.text(data.name);

                    elOrderStatusId.attr("data-order-status-id", data.id);

                    elModal.modal("show");

                }

            },
            error: function (data) {


            },
            complete: function () {


            }

        });

    }, 60000);
};
App.prototype.pageDetector("order-detail-page", orderStatus);
